// ActivityLogModal — shared activity/audit-trail modal used across modules.
// Shows what changed (old → new), who did it, and when. Newest first.

import React from "react";
import { createPortal } from "react-dom";
import { X, History } from "lucide-react";
import { getActionMeta, formatActivityTime } from "../../utils/activityMeta";
import "../../css/sitevisit/activitylog.css";

export default function ActivityLogModal({ log = [], onClose }) {
  const entries = [...log].sort(
    (a, b) => new Date(b.changedAt) - new Date(a.changedAt)
  );

  return createPortal(
    <div className="al-overlay" onClick={onClose}>
      <div className="al-modal" onClick={(e) => e.stopPropagation()}>
        <div className="al-header">
          <h4><History size={16} /> Activity Log</h4>
          <button className="al-close" type="button" onClick={onClose}>
            <X size={18} />
          </button>
        </div>

        <div className="al-body">
          {entries.length === 0 ? (
            <p className="al-empty">No activity recorded yet.</p>
          ) : (
            <ul className="al-timeline">
              {entries.map((e, i) => {
                const meta = getActionMeta(e.action);
                return (
                  <li key={i} className="al-item">
                    <span className={"al-icon " + meta.cls}>{meta.icon}</span>
                    <div className="al-content">
                      <div className="al-line">
                        <strong>{meta.label}</strong>
                        {e.field && e.action !== "created" && (
                          <span className="al-field"> · {e.field}</span>
                        )}
                      </div>
                      {e.action === "note" ? (
                        e.newValue && <p className="al-note-text">{e.newValue}</p>
                      ) : (
                        e.action !== "created" && (e.oldValue || e.newValue) && (
                          <div className="al-change">
                            <span className="al-old">{e.oldValue || "—"}</span>
                            <span className="al-arrow">→</span>
                            <span className="al-new">{e.newValue || "—"}</span>
                          </div>
                        )
                      )}
                      <div className="al-meta">
                        {e.changedByName || e.changedByEmail || "Unknown"}
                        <span className="al-dot">•</span>
                        {formatActivityTime(e.changedAt)}
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    </div>,
    document.body
  );
}
